module.exports = __webpack_public_path__ + "img/ltkfitness-3x.dec7607.jpg";